import React, { useState } from "react";
import PageHeading from "../../../components/PageHeading";

const VendorworkGenerate = () => {
  const [tasks, setTasks] = useState([]); // Initialize with an empty array
  const [formData, setFormData] = useState({
    description: "",
    timePeriod: "",
    amount: "",
    expensesType: "",
    projectName: "",
    dateNumber: "",
  });

  const handleSave = () => {
    // Check if all required fields are filled
    if (
      !formData.description ||
      !formData.timePeriod ||
      !formData.amount ||
      !formData.expensesType ||
      !formData.projectName ||
      !formData.dateNumber
    ) {
      alert("Please fill all the fields before saving.");
      return;
    }

    setTasks([...tasks, { ...formData, status: "Pending" }]);
    setFormData({
      description: "",
      timePeriod: "",
      amount: "",
      expensesType: "",
      projectName: "",
      dateNumber: "",
    });
  };

  // const handleAddMore = () => {
  //   setFormData({
  //     description: "",
  //     timePeriod: "",
  //     amount: "",
  //     expensesType: "",
  //     projectName: "",
  //     dateNumber: "",
  //   });
  // };

  return (
    <div className="container-fluid p-4">
      <PageHeading pagename="Create New Work Order" />

      <div className="row mb-4">
        <div className="col-md-6">
          <label>Expenses Type</label>
          <select
            className="form-select"
            value={formData.expensesType}
            onChange={(e) =>
              setFormData({ ...formData, expensesType: e.target.value })
            }
            required
          >
               <option value="">Select</option>
            <option>Type 1</option>
            <option>Type 2</option>
            <option>Type 3</option>
          </select>
        </div>
        <div className="col-md-6">
          <label>Project Name</label>
          <select
            className="form-select"
            value={formData.projectName}
            onChange={(e) =>
              setFormData({ ...formData, projectName: e.target.value })
            }
            required
          >
               <option value="">Select</option>
            <option>Mall Project</option>
            <option>Office</option>
            <option>Residential</option>
          </select>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-6">
          <label>Amount</label>
          <input
            type="number"
            className="form-control"
            value={formData.amount}
            onChange={(e) =>
              setFormData({ ...formData, amount: e.target.value })
            }
            required
          />
        </div>
        <div className="col-md-6">
          <label>Date Input</label>
          <div className="d-flex gap-2">
            <input
              type="number"
              className="form-control"
              placeholder="Enter Date Number"
              value={formData.dateNumber}
              onChange={(e) =>
                setFormData({ ...formData, dateNumber: e.target.value })
              }
              required
            />
            <select
              className="form-select"
              value={formData.timePeriod}
              onChange={(e) =>
                setFormData({ ...formData, timePeriod: e.target.value })
              }
              required
            >
              <option value="">Select</option>
              <option>Days</option>
              <option>Week</option>
              <option>Month</option>
              <option>Year</option>
            </select>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <label>Work Description</label>
        <textarea
          className="form-control"
          rows="4"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
        ></textarea>
      </div>

      <button className="btn btn-success mb-4" onClick={handleSave}>
        Save
      </button>

      {/* Render the tasks table dynamically */}
      {tasks.length > 0 && (
        <div className="mt-4">
          <PageHeading pagename="Generated Tasks" />
          <table className="table">
            <thead>
              <tr className="table-head">
             
                <th>Expenses Type</th>
                <th>Time Period</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((task, index) => (
                <tr key={index}> 
                    <td>{task.expensesType}</td>
                  <td>{task.timePeriod}</td>
                  <td>{task.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

{/* 
      <div className="d-flex justify-content-start">
        <button className="btn btn-primary mt-4" onClick={handleAddMore}>
          Add More
        </button>
      </div> */}
    </div>
  );
};

export default VendorworkGenerate;
